import styled from "styled-components/macro";
import { PRICING_MOBILE_BREAKPOINT } from "../constants";

export const Container = styled.div`
  width: 300px;
  max-width: 100%;
  min-width: 0;
  flex: 0 1 300px;
  margin-top: 36px;
  text-align: center;

  @media screen and (max-width: ${PRICING_MOBILE_BREAKPOINT}) {
    flex-basis: auto;
    margin-top: 0;
  }

  h3 {
    padding: 24px 16px 12px;
    font-size: 20px;
    font-family: "GT Super Text";
    color: #1cbeb1;
  }

  .popular-banner {
    font-family: Inter;
    font-weight: 500;
    color: #fff;
    font-size: 15px;
    line-height: 20px;
    padding: 8px;
    background: #1ec1a8;
    border-radius: 28px 28px 0 0;
  }

  button {
    &:hover {
      opacity: 0.9;
    }
  }

  .description {
    min-height: 64px;

    p:nth-child(2) {
      font-size: 11px;
    }
  }

  .onboarding-call {
    font-size: 15px;
    margin-left: 10px;
    margin-right: 10px;

    animation: scaleLoop 208s ease-in-out infinite;

    @keyframes scaleLoop {
      0% {
        transform: scale(1);
      }
      1.44% {
        transform: scale(1);
      }
      1.92% {
        transform: scale(1.25);
      }
      2.40% {
        transform: scale(1);
      }
      2.88% {
        transform: scale(1.25);
      }
      3.37% {
        transform: scale(1);
      }
      3.85% {
        transform: scale(1.25);
      }
      4.33% {
        transform: scale(1);
      }
      100% {
        transform: scale(1);
      }
    }
  }

  /* Main body content */
  .content {
    position: relative;
    background: white;
    border-radius: 30px;
    border: 2px solid transparent;
    color: #242424;
    padding-bottom: 24px;
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.15), 0px 1.5px 1.5px rgba(0, 0, 0, 0.1);

    h5 {
      padding: 12px 20px 4px;
      font-size: 32px;
      font-family: "GT Super Text";
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;

      > div {
        display: inline-block;
        font-size: 26px;
        margin-top: 4px;
        margin-right: 2px;
        /* &:nth-of-type(2) {
          margin-left: 2px;
          margin-top: -0px;
        } */
      }
    }

    .time-period {
      color: black;
      font-size: 14px;
      font-family: "GT Super Text";
      font-weight: 400;
      padding-top: 0px;
      padding-bottom: 28px;
    }

    .allotment-section {
      min-height: 135px;
      padding: 20px 12px 0;

      .doubled,
      .quadrupled {
        margin-top: 32px;
        font-size: clamp(28px, 3vw, 42px);
        color: #1fc2a9;
        font-weight: 700;
        transform: rotate(3deg);
        position: relative;
        letter-spacing: -0.05em;

        div {
          display: inline;
          position: absolute;
          letter-spacing: normal;
          color: white;
          font-weight: 500;
          background: #1fc2a9;
          border-radius: 18px;
          font-size: 13px;
          font-family: Inter;
          transform: rotate(-10deg);
          top: -32px;
          right: 0;
          padding: 7px 12px;
          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);

          svg {
            position: absolute;
            bottom: -27px;
            left: 50%;
            width: 20px;
            transform: translateX(-50%);
          }
        }
      }

      h6 {
        padding: 10px;
        padding-top: 25px;
        font-size: 32px;
        font-weight: bolder;
        font-family: "GT Super Text";
        position: relative;

        &.half {
          display: inline;
          padding-top: 5px;
        }

        &.half::before,
        .half::after {
          content: "";
          width: 100%;
          position: absolute;
          right: 0;
          top: calc(50%);
        }
        &.half::before {
          border-bottom: 4px solid #1fc2a9;
          transform: skewY(-2deg);
        }
      }
    }

    .words-explainer {
      position: relative;
      display: block;
      color: black;
      font-size: 18px;
      font-weight: normal;
      font-family: "GT Super Text";
      padding-bottom: 5px;
      padding-top: 5px;
      margin: 0px 10px 0px 10px;
    }

    em {
      color: rgb(30, 193, 168);
      font-weight: 600;
      font-style: normal;
    }

    .bottom {
      margin-top: 12px;
      /* Reserve the button and caption space for current/upcoming plans too. */
      min-height: 88px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;

      .current-plan {
        text-align: center;
        font-family: "Inter";
        color: #21c7a0;
        font-size: 16px;
        margin: 24px 12px;
        font-weight: 500;

        &.legacy {
          color: #000000;
          opacity: 0.4;
          font-family: "GT Super Text";
        }

        &.short {
          margin-top: 0px;
          margin-bottom: 0px;
        }
      }
      span {
        font-weight: 500;
      }
    }

    p {
      padding: 18px;
      font-size: 15px;
      padding-top: 0;
      font-family: "GT Super Text";
      line-height: 1.4em !important;
    }

    button {
      /* padding: 20px; */
      font-size: 16px;
      cursor: pointer !important;
      width: 195px;
      max-width: calc(100% - 24px);
      border-radius: 10px !important;
      background: linear-gradient(to right, rgb(44, 220, 118) -100%, rgb(16, 168, 217) 200%) !important;
      box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.25) !important;
    }

    .features {
      list-style: none;
      padding: 24px 20px 0;
      margin: 16px 0 0;
      text-align: left;
      font-family: "GT Super Text", serif;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #423521;
      overflow-wrap: anywhere;

      li {
        position: relative;
        padding-left: 22px;
        margin-bottom: 16px;

        &::before {
          content: "✓";
          position: absolute;
          left: 0;
          font-family: Inter, sans-serif;
          color: #159b87;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }

      small {
        display: block;
        color: rgba(66, 53, 33, 0.7);
        font-family: Inter, sans-serif;
        font-size: 12px;
      }

      strong {
        font-weight: 700;
      }
    }

    span {
      font-family: "Inter";
      padding: 10px;
      font-size: 11px;
      display: block;
      color: #888;
    }
  }

  .intervalMessage {
    font-family: Inter;
    font-size: 18px;
    color: #7b7972;
    font-weight: 500;
    opacity: 0.7;
    margin: auto;
    margin-top: 25px;
    width: 80%;
    line-height: 23px;
  }

  .legacy {
    margin: 30px auto 20px auto;
  }

  .under {
    button {
      background: none !important;
      width: 100%;
      border-radius: 10px !important;
      color: #1ec1a8 !important;
      border: 2px solid #1ec1a8 !important;
    }

    .under-buttons {
      padding-top: 8px !important;
      padding-right: 39px !important;
      padding-left: 39px !important;
      margin-top: 6px !important;
      margin-bottom: 9px;
    }

    span {
      display: block;
      margin: 15px;
      margin-top: 25px;
      font-family: "Inter";
      color: #87857d;
      font-weight: 500;
      font-size: 14px;
    }

    height: auto;
    margin-bottom: 30px;
  }

  &.position-0,
  &.position-1,
  &.position-2,
  &.position-comparison {
    .content {
      margin-top: 0px;

      button {
        border-radius: 10px !important;
        background: linear-gradient(to right, rgb(44, 220, 118) 0%, rgb(16, 168, 217) 300%) !important;
        box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.25) !important;
      }
    }

    .under {
      button {
        color: #25ce8f !important;
        border: 2px solid #25ce8f !important;
      }
    }

    &.popular {
      margin-top: 0px;

      .content {
        border-color: #1ec1a8;
      }
    }
  }

  &.position-comparison {
    h3 {
      color: #000;
      opacity: 0.4;
    }
  }

  &.position-0 {
    h3 {
      color: #25ce8f;
    }
    .content {
      button {
        border-radius: 10px !important;
        background: linear-gradient(to right, rgb(44, 220, 118) 0%, rgb(16, 168, 217) 300%) !important;
        box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.25) !important;
      }
    }
  }

  &.position-1 {
    h3 {
      color: #16b3c4;
    }

    h6 {
      margin-top: -5px;
    }

    .content {
      button {
        background: #1cbeb1 !important;
        border-radius: 10px !important;
        background: linear-gradient(to right, rgb(44, 220, 118) -200%, rgb(16, 168, 217) 100%) !important;
        box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.25) !important;
      }
    }
    .under {
      button {
        color: #16b3c4 !important;
        border: 2px solid #16b3c4 !important;
      }
    }
    .description2 {
      font-size: 15px;
    }
  }

  &.position-2 {
    h3 {
      color: #1cbeb1;
    }

    h6 {
      margin-top: -5px;
    }
    .content {
      button {
        border-radius: 10px !important;
        background: linear-gradient(to right, rgb(44, 220, 118) -300%, rgb(16, 168, 217) 0%) !important;
        box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.25) !important;
      }
    }
    .under {
      button {
        color: #16b3c4 !important;
        border: 2px solid #16b3c4 !important;
      }
    }
    .description2 {
      font-size: 15px;
    }
  }
`;

export const StyledAIWordsPopover = styled.div`
  position: absolute;
  background: white;
  left: 0;
  right: 0;
  margin: auto;
  padding: 10px;
  bottom: 100%;
  border-radius: 10px;
  transition: opacity 0.3s ease-in-out;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
  opacity: 0;
  z-index: 10000;
  ${({ popoverHovering }) => popoverHovering && `opacity: 1;`}
  ${({ isMobile, popoverShowing }) => isMobile && popoverShowing && `opacity: 1;`}

  font-size: 14px;
  margin: 0;
  line-height: 1.5em;

  div {
    float: right;
    cursor: pointer;
    opacity: 0.8;
    &:hover {
      opacity: 1;
    }
  }
`;
